import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteDocumentById = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PROFESSIONAL.DELETE_DOCUMENT,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteDocumentById